import { object, string } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import MomentCard from '../../WeekView/MomentCard'

import './styles.scss'

const PreviewCard = ({ className, moment }) => (
  <div className={kuiperClassNames(className)}>
    <MomentCard
      contextMenuCallbacks={{}}
      draggedMomentParams={null}
      isExpanded={false}
      isMomentDragActive={false}
      isLoadingMoments={false}
      isPlaceholderCard={false}
      moment={moment}
      pivotName=""
      registerDraggedMoment={() => {}}
    />
  </div>
)

PreviewCard.propTypes = {
  className: string,
  moment: object,
}

export default PreviewCard
